// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1eE8R","link":"Card_link__3UK6S","title":"Card_title__2pVhP"};